import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { showSideBar } from "../../store/actions";
import Hamburger from "./Hamburger";
import SideMenuContent from "./SideMenuContent";
import { Trans, useTranslation } from "react-i18next";

function LeftMenu(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoggedIn = sessionStorage.getItem("token") ? true : false;
  const isSideBarOpen = useSelector(
    (state) => state?.CommonState?.showSideBar ?? false,
  );

  // Lock the page behind the drawer so scrolling the sidebar doesn't scroll the
  // main page (RN: the drawer overlays a frozen screen). The drawer scrolls via
  // its own `.BLM-sideMenu-main-content` (overflow-y: auto).
  useEffect(() => {
    const body = document.body;
    if (isSideBarOpen) {
      const prev = body.style.overflow;
      body.style.overflow = "hidden";
      return () => {
        body.style.overflow = prev;
      };
    }
    body.style.overflow = "";
    return undefined;
  }, [isSideBarOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      const sideMenu = document.querySelector(".BLM-sideMenu");
      if (sideMenu && !sideMenu.contains(event.target)) {
        dispatch(showSideBar(false));
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch]);

  return (
    <>
      <div
        className="BLM-leftMenu-mask"
        id="BLM-leftMenu-mask"
        onClick={() => {
          // dispatch(showSideBar(false));
        }}
      />
      <div className="BLM-sideMenu">
        <div className="BLM-sideMenu-main-content">
          <div className="BLM-sideMenu-container">
            <div
              className="BLM-language-container d-none"
              id="getLanguageDropdown"
            >
              <div className="BLM-label"><Trans i18nKey="language_selector_label">Language</Trans>:</div>
              <div className="BLM-select">
                <select id="ddn_languages" defaultValue="en">
                  <option value="en"><Trans i18nKey="language_english">English</Trans></option>
                  <option value="sw-KE"><Trans i18nKey="language_swahili">Swahili</Trans></option>
                </select>
              </div>
            </div>
            {!isLoggedIn && (
              <div className="SB-tabs-boxed">
                <ul className="sidemenu-tablist row" id="Sidemenu_tabs">
                  <li className={`col-10 active truncate`}><Trans i18nKey="left_menu_menu">Menu</Trans></li>

                  <div
                    id="sidebar_trigger"
                    className=""
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      dispatch(showSideBar(false));
                    }}
                  >
                    <button type="button" className="btn-close btn-close-white btn-cls-ham" aria-label={t("left_menu_close", "Close")}></button>
                  </div>
                </ul>
              </div>
            )}
            <SideMenuContent isLoggedIn={isLoggedIn} />
          </div>
        </div>
      </div>
      {/* <div className="BLM-rightMenu" id="betslipDisplay"></div> */}
      {/* <div className="BLM-rightMenu-mask" /> */}
    </>
  );
}

export default LeftMenu;
